import { iconDoneAll, img1, img2, img3, img4, img5 } from "../assets";
import useDevice from "../util";

const WhoWe = () => {
  const device = useDevice();

  return (
    <div className="w-[100vw] h-[auto] px-[20px] pb-[77px] pt-[270px] sm:pt-[130px] lg:pt-0 bg-[#F6FAFD] flex flex-col justify-center">
      <div className="flex flex-col sm:flex-row justify-center items-center">
        <div className="sm:w-[100%] lg:w-[610px] mt-[30px] flex flex-col flex-wrap">
          <div className="text-[#333333] text-[24px] font-[700] sm:text-[30px] lg:text-[36px] border-b-[6px] pb-[15px] w-fit border-[#005DD7] mb-[20px] text-center">
            CHÚNG TÔI LÀ AI ?
          </div>
          <div className="text-who-me">
            <img className="h-fit mr-[10px]" src={iconDoneAll} alt="" />
            <div>
              <div>Kênh tư vấn bảo hiểm nhân thọ chuyên nghiệp thuộc</div>
              <div>Tổng Công ty Bảo Việt Nhân thọ</div>
            </div>
          </div>
          <div className="text-who-me">
            <img className="h-fit mr-[10px]" src={iconDoneAll} alt="" />
            <div>Giải pháp tài chính cho cuộc sống thông minh</div>
          </div>
          <div className="text-who-me">
            <img className="h-fit mr-[10px]" src={iconDoneAll} alt="" />
            <div>
              Chuyên gia tư vấn tài chính cá nhân, phục vụ chuyên nghiệp 24/7
              cho riêng bạn
            </div>
          </div>
          <div className="flex items-center sm:gap-[20px]">
            <div className="text-[#767676] text-[16px] font-[400] lg:text-[20px] text-justify">
              Life Pro cùng bạn thực hiện điều bạn mong muốn. Life Pro cung cấp
              tới bạn những dịch vụ, sản phẩm tốt nhất, tận tâm phục vụ bạn vì
              sức khoẻ, tương lai và hạnh phúc của bạn. Chúng tôi tự hào là thế
              hệ Tư vấn tài chính 2.0 của Tổng Công ty Bảo Việt Nhân thọ, với
              tầm nhìn trở thành mô hình kiểu mới đại diện cho TVTC bảo hiểm
              chuyên nghiệp và toàn thời gian. Lộ trình tiếp tục phát triển từ
              các thị trường trọng điểm hiện tại như Hà Nội, TP Hồ Chí Minh, Đà
              Nẵng và mở rộng tới các tỉnh thành trên toàn quốc trong giai đoạn
              2025-2030.
            </div>
            {device === "tablet" && (
              <img className="max-h-[258px] w-fit" src={img1} alt="" />
            )}
          </div>
          {device === "mobile" && (
            <img
              className="max-h-[232px] w-fit mt-[20px] mx-auto"
              src={img1}
              alt=""
            />
          )}
        </div>
        {device === "desktop" && (
          <img className="ml-[20px] max-h-[318px] w-fit" src={img1} alt="" />
        )}
      </div>
      <div className="flex mx-auto mt-[30px] gap-[20px] overflow-auto w-fit">
        <img
          className="w-[261px] rounded-[10px] border border-[#005DD7]"
          src={img2}
          alt=""
        />
        <img
          className="w-[261px] rounded-[10px] border border-[#005DD7]"
          src={img3}
          alt=""
        />
        <img
          className="w-[261px] rounded-[10px] border border-[#005DD7]"
          src={img4}
          alt=""
        />
        <img
          className="w-[261px] rounded-[10px] border border-[#005DD7]"
          src={img5}
          alt=""
        />
      </div>
    </div>
  );
};

export default WhoWe;
